export const enum ReleaseType {
    PROPERTY = "Property",
    MODEL = "Model",
}